import 'babel-polyfill';
import Vue from 'vue';
import AsyncComputed from 'vue-async-computed';
import './plugins/axios';

import router from './router'
Vue.config.productionTip = false;

import 'jquery';

import 'chart.js';
import 'chartjs-plugin-colorschemes';
import 'chartjs-plugin-datalabels';

import "leaflet/dist/leaflet.css";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";

import RepositoryFactory from "@/services/RepositoryFactory";

RepositoryFactory.get('version').doUpdate();

Vue.use(AsyncComputed);

// Configure multi-language.
import VueI18n from 'vue-i18n';
import en from '@/lang/en.json'
import fr from '@/lang/fr.json'

Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: 'en',
  messages: { en, fr },
  silentTranslationWarn: true
})

// Vuetify Material Design.
import Vuetify from 'vuetify'
Vue.use(Vuetify, {
  theme: {
    primary: '#003159',
    secondary: '#ffffff'
  }
});
import 'vuetify/dist/vuetify.min.css'

// Components.
import AppHeader from './components/AppHeader';
import AppFooter from './components/AppFooter';

// store vuex.
import store from './store'

// Leaftlet.
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.icon.glyph';
import 'leaflet-providers';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

// Leaflet markercluster.
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
Vue.component('v-marker-cluster', Vue2LeafletMarkerCluster);
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

Vue.component('app-header', AppHeader);
Vue.component('app-footer', AppFooter);

import App from './App.vue';
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "GTM-W7S2QKX" }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
